import { Debit, Patient } from 'interfaces';
import { buildDebit } from '../../factories';
import {
  patientRefs,
  payorRefs,
  providerRefs,
  tariffRefs,
} from '../../factories/seeds/entities';
import { mockClaims } from './claimMock';
import { mockPayors } from './payorMock';
import { mockPatients } from './patientMock';
import { mockProviders } from './providerMock';
import { mockTariffs } from './tariffMock';

const payorByID = new Map(mockPayors.map((payor) => [payor.id, payor]));
const patientByID = new Map(mockPatients.map((patient) => [patient.id, patient]));
const providerByID = new Map(
  mockProviders.map((provider) => [provider.id, provider])
);
const tariffByID = new Map(mockTariffs.map((tariff) => [tariff.id, tariff]));

const primaryClaim =
  mockClaims.find((claim) => claim.id === '5563a744-9a0a-41d6-89b9-c6f5002cc3de') ??
  null;
const primaryPayor = payorByID.get(payorRefs.mb.id) ?? null;
const primaryPatient = patientByID.get(patientRefs.adamLowry.id) ?? null;
const remittanceProvider = providerByID.get(providerRefs.weezerRockMusic.id) ?? null;
const firstTariff = tariffByID.get(tariffRefs.virtual8447.id) ?? null;
const secondTariff = tariffByID.get(tariffRefs.premium5550.id) ?? null;

export const mockDebits: Array<Debit & { patient?: Patient }> = [
  buildDebit<Debit & { patient?: Patient }>({
    id: '586569c9-abd8-4511-b135-79e6f29fb079',
    claimID: primaryClaim?.id ?? '',
    payorID: primaryPayor?.id ?? '',
    requestedAmount: '104.07',
    paidAmount: '101.53',
    microfilm: '03123799',
    createdAt: '2025-02-07T00:28:51.172Z',
    status: 'processed',
    type: 'PAYMENT',
    source: 'REMITTANCE',
    providerID: remittanceProvider?.id ?? '',
    tariffID: firstTariff?.id ?? '',
    claim: primaryClaim ?? undefined,
    patient: primaryPatient ?? undefined,
    tariff: firstTariff ?? undefined,
  }) as Debit & { patient?: Patient },
  buildDebit<Debit & { patient?: Patient }>({
    id: '7aec5cf2-6528-4fe4-ad4a-f6fe5049c5d1',
    claimID: primaryClaim?.id ?? '',
    payorID: primaryPayor?.id ?? '',
    requestedAmount: '53.34',
    paidAmount: '50.77',
    microfilm: '03123799',
    createdAt: '2025-02-07T00:28:51.491Z',
    status: 'processed',
    type: 'PAYMENT',
    source: 'REMITTANCE',
    providerID: remittanceProvider?.id ?? '',
    tariffID: secondTariff?.id ?? '',
    claim: primaryClaim ?? undefined,
    patient: primaryPatient ?? undefined,
    tariff: secondTariff ?? undefined,
  }) as Debit & { patient?: Patient },
];
